import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Tooltip,
  // CircularProgress,
  TablePagination,
} from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useMutation } from "react-query";
import {
   getAllUploadedDocuments, 
  // viewUploadedDocments 
} from "./services";
import { UploadedDocumentsParams, UploadedDocumentsResponseType } from "./types";
import { useParams } from "react-router-dom";
import PreviewIcon from '@mui/icons-material/Preview';
// import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
// import usePrint from "@hooks/usePrint";

type UploadedDocumentsProps = {
  /** When set (e.g. Patient History drill-down), overrides router encounterId */
  encounterId?: number;
};

const UploadedDocuments: FC<UploadedDocumentsProps> = ({
  encounterId: encounterIdOverride,
}) => {
    const { encounterId: encounterIdParam } = useParams<{ encounterId?: string }>()
    // const {printPdf,loading} = usePrint()
    // const {showSnackbar} = usePopup()
    const {user} = useAuthentication()

    const resolvedEncounterId = useMemo(() => {
      if (
        encounterIdOverride != null &&
        Number.isFinite(encounterIdOverride) &&
        encounterIdOverride > 0
      ) {
        return encounterIdOverride;
      }
      const fromRoute = encounterIdParam != null ? Number(encounterIdParam) : NaN;
      return Number.isFinite(fromRoute) ? fromRoute : NaN;
    }, [encounterIdOverride, encounterIdParam]);

    const [searchParams,setSearchParams] = useState<UploadedDocumentsParams>(() => ({
        encounterId: resolvedEncounterId,
        pageNumber:0,
        pageSize:25,
        sortField:"",
        sortOrder:"asc",
        clinicId:Number(user?.clinicId)
    }))
    const [list,setList] = useState<UploadedDocumentsResponseType[]>([])
    // const [selected,setSelected] = useState(-1)
    const {mutate,isLoading,data} = useMutation(getAllUploadedDocuments,{
        onSuccess:(result)=>{
               if(result.responseIndicator == "success"){
                   setList(result.response.items)
               }
        }
    })


// const {mutate:viewFile,isLoading:viewLaoding} = useMutation(viewUploadedDocments,{
//     onSuccess:(result)=>{
//        if(result.responseIndicator == "success"){
//         printPdf(String(result.response.content),"new-tab",)
//        }else{
//          showSnackbar({
//            message:result.responseMessage,
//            open:true,
//            variant:"warning",
//            duration:3000
//          })
//        }
//     },
//     onError:(e:any)=>{
//          showSnackbar({
//            message:e?.response?.data?.responseMessage || e.response.message || "Something went wrong !",
//            open:true,
//            variant:"warning",
//            duration:3000
//          })
//     }
// })

const handleViewFile = (path:string,index:number)=>{
    // viewFile({uploadFile:path,clinicId:Number(user?.clinicId)})
    // setSelected(index)
    console.log(index);
    window.open(path, "_blank");
} 

const handleChangePage = (_: unknown, pageNumber: number) => {
    setSearchParams({
        ...searchParams,
        pageNumber
    });
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const pageSize = parseInt(event.target.value, 10)
    setSearchParams((prev)=>({
        ...prev,
        pageNumber:0,
        pageSize
    }));
  };

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      encounterId: resolvedEncounterId,
      clinicId: Number(user?.clinicId),
      pageNumber: 0,
    }));
  }, [resolvedEncounterId, user?.clinicId]);

  useEffect(() => {
    if (!Number.isFinite(searchParams.encounterId)) return;
    mutate(searchParams);
    // mutate identity from react-query is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run fetch when params change
  }, [searchParams]);
  return (
    <TableContainer className="min-w-[50vw]">
      <Table size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            {heading.map((item,index) => (
              <TableCell key={index}>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert={"No records"}
          dataLoading={isLoading}
          isData={Boolean(list.length)}
          totalSpan={{ col: heading.length, row: 5 }}
        >
          {list.map((item, index) => (
            <TableRow key={item.id ?? `${item.uploadFile}-${index}`}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{item.documents}</TableCell>
              <TableCell>
                <Tooltip title="View file">
                <IconButton color="primary" onClick={()=>{handleViewFile((item as any).url,index)}}>
                    {/* {((viewLaoding) && selected == index) ? <CircularProgress size={18} /> : <PreviewIcon/>} */}
                    <PreviewIcon/>
                </IconButton>
                </Tooltip>
                </TableCell>
            </TableRow>
          ))}
        </CustomTableBody>
      </Table>
      <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={data?.response.totalcount || 0}
          rowsPerPage={searchParams.pageSize}
          page={searchParams.pageNumber}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </TableContainer>
  );
};

export default UploadedDocuments;

const heading = ["SL NO", "NAME", "ACTIONS"];

// const mimeTypes = {
//     jpg: "image/jpeg",
//     jpeg: "image/jpeg",
//     png: "image/png",
//     gif: "image/gif",
//     bmp: "image/bmp",
//     webp: "image/webp",
//     "svg+xml": "image/svg+xml",
//     ico: "image/x-icon",
//     mp4: "video/mp4",
//     webm: "video/webm",
//     ogg: "video/ogg",
//     "x-msvideo": "video/x-msvideo",
//     mpeg: "video/mpeg",
//     plain: "text/plain",
//     html: "text/html",
//     json: "application/json",
//     csv: "text/csv",
//     xml: "text/xml",
//     css: "text/css",
//     js: "text/javascript",
//     markdown: "text/markdown",
//     pdf: "application/pdf",
//     msword: "application/msword",
//     "vnd.ms-excel": "application/vnd.ms-excel",
//     "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     "vnd.ms-powerpoint": "application/vnd.ms-powerpoint",
//     "vnd.openxmlformats-officedocument.presentationml.presentation":
//       "application/vnd.openxmlformats-officedocument.presentationml.presentation",
//     wav: "audio/wav",
//     aac: "audio/aac",
//     mp3: "audio/mpeg",
//     zip: "application/zip",
//     tar: "application/x-tar",
//     "x-7z-compressed": "application/x-7z-compressed",
//     rar: "application/vnd.rar",
//     jsonld: "application/ld+json",
//     yaml: "text/yaml",
//   };
  